<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          :color="this.color"
          append-icon="mdi-pencil-outline"
          v-bind="props"
          :class="this.text ? '' : 'button'"
          variant="text"
        >
          {{ this.text }}
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Editar Caso de Uso</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="identificador"
                    label="Identificador*"
                    required
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="9">
                  <v-text-field
                    v-model="nome"
                    required
                    label="Nome*"
                    :rules="nomeRules"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="gatilho"
                    label="Gatilho*"
                    required
                    :rules="gatilhoRules"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="preCondicao"
                    label="Pré-Condição*"
                    required
                    :rules="preCondicaoRules"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="descricao"
                    required
                    label="Descrição*"
                    rows="3"
                    :rules="descricaoRules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="observacao"
                    required
                    label="Observação*"
                    rows="3"
                    :rules="observacaoRules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-select
                    v-model="prioridade"
                    :items="['Urgente', 'Alta', 'Media', 'Baixa']"
                    label="Prioridade*"
                    required
                    :rules="prioridadeRules"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-select
                    v-model="storypoint"
                    :items="['0', '0.5', '1', '2', '3', '5', '8', '13', '?']"
                    label="Storypoint"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="yellow-darken-4"
            variant="text"
            @click="saveDraft"
            v-if="this.casoDeUsoP.status === 'EM_EDICAO'"
          >
            Salvar Rascunho
            <v-tooltip activator="parent" location="top"
              >As alterações feitas não serão registradas no
              histórico.</v-tooltip
            >
            <v-progress-circular
              v-if="this.isLoadingDraft"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>

          <v-btn color="blue-darken-1" variant="text" @click="handleUpdate">
            Atualizar
            <v-tooltip activator="parent" location="top"
              >As alterações feitas serão registradas no histórico.</v-tooltip
            >
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-dialog v-model="showDialog" max-width="512">
    <v-card>
      <v-card-title class="headline"> Confirmação </v-card-title>

      <v-card-text>
        O caso de uso já está definido? Caso haja a confirmação, o controle de
        histórico do caso de uso será iniciado.
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn color="red darken-1" dark @click="showDialog = false">Não</v-btn>
        <v-btn
          color="blue darken-1"
          dark
          @click="
            () => {
              submitForm();
              showDialog = false;
            }
          "
          >Sim</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * @module EditCSU
 * @desc Modal com o formulário para a edição de um caso de uso.
 * @vue-data {Boolean} [dialog=false] - Flag que indica se o modal está visível
 * @vue-data {String} [nome=''] - Nome do caso de uso
 * @vue-data {String} [prioridade=''] - Prioridade do caso de uso
 * @vue-data {String} [identificador=''] - Identificador do caso de uso
 * @vue-data {String} [descricao=''] - Descrição do caso de uso
 * @vue-data {String} [storypoint=''] - Storypoint do caso de uso
 * @vue-data {String} [gatilho=''] - Gatilho do caso de uso
 * @vue-data {String} [preCondicao=''] - Pré-condição do caso de uso
 * @vue-data {String} [observacao=''] - Observação do caso de uso
 * @vue-data {Boolean} [isLoading=false] - Flag que indica se o caso de uso
 * ainda está sendo editado
 * @vue-data {Boolean} [isLoadingDraft=false] - Flag que indica se o rascunho
 * do caso de uso ainda está sendo salvo
 * @vue-data {Boolean} [showDialog=false] - Flag que indica se o modal para
 * confirmação está visível
 */
import axios from 'axios';

import store from '@/store/store';

export default {
  props: {
    id: Number,
    // eslint-disable-next-line vue/require-default-prop
    casoDeUsoP: {
      type: Object,
    },
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'green-darken-2',
    },
  },
  emits: ['casoDeUsoEditado', 'rascunhoSalvo'],
  data: () => ({
    dialog: false,
    nome: '',
    prioridade: '',
    identificador: '',
    descricao: '',
    storypoint: '',
    gatilho: '',
    preCondicao: '',
    observacao: '',
    isLoading: false,
    isLoadingDraft: false,
    showDialog: false,
    nomeRules: [
      (v) => !!v || 'Nome é obrigatório',
      (v) => (v && v.length <= 100) || 'Nome deve ter no máximo 100 caracteres',
    ],
    gatilhoRules: [
      (v) => !!v || 'Gatilho é obrigatório',
      (v) =>
        (v && v.length <= 100) || 'Gatilho deve ter no máximo 100 caracteres',
    ],
    preCondicaoRules: [
      (v) => !!v || 'Pré-condição é obrigatória',
      (v) =>
        (v && v.length <= 100) ||
        'Pré-condição deve ter no máximo 200 caracteres',
    ],
    descricaoRules: [
      (v) => !!v || 'Descrição é obrigatória',
      (v) =>
        (v && v.length <= 100) || 'Descrição deve ter no máximo 500 caracteres',
    ],
    observacaoRules: [
      (v) => !!v || 'Observação é obrigatória',
      (v) =>
        (v && v.length <= 100) ||
        'Observação deve ter no máximo 500 caracteres',
    ],
    prioridadeRules: [(v) => !!v || 'Prioridade é obrigatória'],
  }),
  mounted() {
    // Esse procedimento deveria ser feito em 'data', mas por alguma
    // razão ele não funciona lá
    this.nome = this.casoDeUsoP.nome;
    this.prioridade = this.casoDeUsoP.prioridade;
    this.identificador = this.casoDeUsoP.identificador;
    this.descricao = this.casoDeUsoP.descricao;
    this.storypoint = this.casoDeUsoP.storypoint;
    this.gatilho = this.casoDeUsoP.gatilho;
    this.preCondicao = this.casoDeUsoP.pre_condicao;
    this.observacao = this.casoDeUsoP.observacao;

    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com a funcionalidade de atualizar o caso de uso.
     */
    handleUpdate() {
      if (this.casoDeUsoP.status === 'EM_EDICAO') {
        this.showDialog = true;
      } else {
        this.submitForm();
      }
    },

    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para salvar o rascunho do caso de uso.
     */
    async saveDraft() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          gatilho: this.gatilho,
          nome: this.nome,
          // eslint-disable-next-line camelcase
          pre_condicao: this.preCondicao,
          descricao: this.descricao,
          prioridade: this.prioridade.toUpperCase(),
          storypoint: parseFloat(this.storypoint),
          observacao: this.observacao,
        };

        try {
          this.isLoadingDraft = true;
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.put(
            `${apiUrl}/api/v1/productBacklog/${this.id}/rascunho`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          this.$toast.success(response.data.msg);
          this.$emit('rascunhoSalvo', this.id);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoadingDraft = false;
          this.dialog = false;
        }
      }
    },

    /**
     * Realiza uma requisição HTTP para editar um determinado caso de uso.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          identificador: this.identificador,
          gatilho: this.gatilho,
          nome: this.nome,
          // eslint-disable-next-line camelcase
          pre_condicao: this.preCondicao,
          descricao: this.descricao,
          prioridade: this.prioridade.toUpperCase(),
          storypoint: parseFloat(this.storypoint),
          observacao: this.observacao,
        };

        try {
          this.isLoading = true;
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.put(
            `${apiUrl}/api/v1/productBacklog/${this.id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          const newID = response.data.id;
          const projectID = this.$route.params.idProjeto;

          this.$toast.success(response.data.msg);
          this.$emit('casoDeUsoEditado', newID);

          if (this.text) {
            this.$router.push(`/projects/${projectID}/CasoUso/${newID}`);
          }
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>
<style scoped>
.button {
  min-width: 0;
  width: 0;
  padding: 0.4px;
}
</style>
